import { render, staticRenderFns } from "./home-provider.vue?vue&type=template&id=4794139a&"
import script from "./home-provider.vue?vue&type=script&lang=js&"
export * from "./home-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports